import Page from 'components/modules/public/pages/About';
export default Page;